module.exports = __webpack_public_path__ + "static/media/notifications.4390fa58.svg";